import { render, staticRenderFns } from "./InterventionEditorConfigElement.vue?vue&type=template&id=8c6b4224"
import script from "./InterventionEditorConfigElement.vue?vue&type=script&lang=js"
export * from "./InterventionEditorConfigElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports